import { IDS } from '../master-doc-list-action-id.constants';
import { IDS as REQUIREMENTS_ASSESSMENT_IDS } from '../../requirements-assessment/requirements-assessment-action-id.constants';
import {TYPES} from "../master-doc-list-action-type.constants";
import * as MasterDocListActions from '../master-doc-list.actions';
import { TAB_SELECT, TAB_SHOW } from '../../../../common/tabs/tabs.constants'
import {GRID_RELOAD} from "../../../../common/grid/grid.constants";
import has from "lodash/has";
import {formatDate} from "../../../../common/utils/util.date";
import {DATE_FORMAT} from "../../../../common/utils/util.constants";

/**
 * Creates a new AccDocumentDetailsController.
 * @class
 */
export const masterDocListDetails = {
    /* @ngInject */
    controller: function($ngRedux, $state, $stateParams, $scope, $rootScope, $filter, NavigationService, AuthService, Notifier, FileActions) {
        this.$onInit = async () => {
            this.identifier = IDS.masterDocList;
            this.parentState = IDS.app_accreditation_scheme_master_doc_list;

            this.unsubscribe = $ngRedux.connect(state => {
                const masterDocList = state.accreditation.masterDocList;

                const document = masterDocList.masterDocListDetails;

                const textId = `COMMON.DOCUMENT.CODE.${document?.type_code.toUpperCase()}`;
                let typeName = $filter('translate')(textId);
                if(typeName === textId)
                    typeName = document.type_name;

                return {
                  typeName,
                  document,
                  schemeName: masterDocList.frameworkDetails.name,
                  siteLocationUuid: masterDocList.masterDocListDetails.slo_uuid,
                  headOfficeUuid: null,
                  year: masterDocList.masterDocListDetails.fiscal_year,
                };
            }, {
                ...FileActions,
                ...MasterDocListActions,
            })(this);
            this.title = `${this.document.name}`;
            this.schemeCode = $stateParams.itemCode;

            // this.getRegulatoryFrameworkDetails(this.schemeCode).then(scheme => {
            //     this.fetchEnabledHeadOffices(scheme.id).then(headOffices => {})
            // })
        }

        this.onTemplateUploadSave = (event) => {
            $ngRedux.dispatch({
              type: TYPES.DOCUMENT_SAMPLE_DOC_CHANGED,
              id: this.identifier,
              path: IDS.masterDocListDetails,
              template: event[0].filePath,
            });
        }

        this.onRequirementsGridSelect = ({item}) => {
            if(!!this.year) {
              $state.go(
                REQUIREMENTS_ASSESSMENT_IDS.app_accreditation_scheme_requirements_assessment_evidence_groups_list,
                {
                  itemCode: this.schemeCode,
                  requirement: item.id,
                  year: this.year,
                  slo: this.siteLocationUuid,
                  hof: this.headOfficeUuid,
                },
              );
            }
        }

        this.onSaveChangesButton = () => {
            $scope.$broadcast('show-errors-check-validity', '$ctrl.masterDocListDetailsForm');

            if (this.masterDocListDetailsForm.$valid === false) {
                Notifier.error('COMMON.FIELDS_REQUIRED');
                return;
            }

            this.editMasterDocListDocument({
                uuid:           this.document.id,
                name:           this.document.name,
                number:         this.document.doc_num,
                // doc_date:       formatDate(this.document.doc_date, DATE_FORMAT.OUTPUT),
                // due_date:       formatDate(this.document.due_date, DATE_FORMAT.OUTPUT),
                template:       this.document.template,
            }).then(() => {
                $ngRedux.dispatch({
                    type: TAB_SELECT,
                    id: this.parentState,
                    state: IDS.app_accreditation_scheme_master_doc_list_list
                });
            });
        }

        this.$onDestroy = () => {
            this.unsubscribe();
        }

    },
    template: require('./master-doc-list-details.html')
}
